import { useDispatch } from 'store/hooks';
import { useCallback } from 'react';
import {
    showWarningAsync,
    showInfoAsync,
    showNotificationAsync,
} from './thunks';
import { NotificationType } from '@instinet-analytics/semantic-ui-components';

export const useDispatchShowNotification = () => {
    const dispatch = useDispatch();
    return useCallback(
        (message: string, type: NotificationType, title?: string) =>
            dispatch(showNotificationAsync(message, type, title)),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );
};

export const useDispatchShowWarning = () => {
    const dispatch = useDispatch();
    return useCallback(
        (message: string, title?: string) =>
            dispatch(showWarningAsync(message, title)),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );
};

export const useDispatchShowInfo = () => {
    const dispatch = useDispatch();
    return useCallback(
        (message: string, title?: string) =>
            dispatch(showInfoAsync(message, title)),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );
};
